import { useEffect, useState } from "react";

export const SKELETON_FADE_MS = 200;

export const skeletonCrossfadeClassName = (visible: boolean): string =>
  [
    "absolute inset-0 z-0 rounded-[inherit] transition-opacity duration-200",
    visible ? "opacity-100" : "opacity-0",
  ].join(" ");

/** Fade skeleton in while `shouldShow` is true; fade out when it becomes false. */
export const useSkeletonCrossfade = (
  shouldShow: boolean,
  resetKey: unknown,
): { skeletonActive: boolean; skeletonClassName: string } => {
  const [skeletonActive, setSkeletonActive] = useState(shouldShow);
  const [skeletonVisible, setSkeletonVisible] = useState(false);

  useEffect(() => {
    if (!shouldShow) return;

    let raf2 = 0;
    const raf1 = requestAnimationFrame(() => {
      setSkeletonActive(true);
      setSkeletonVisible(false);
      raf2 = requestAnimationFrame(() => {
        setSkeletonVisible(true);
      });
    });

    return () => {
      cancelAnimationFrame(raf1);
      cancelAnimationFrame(raf2);
    };
  }, [shouldShow, resetKey]);

  useEffect(() => {
    if (shouldShow || !skeletonActive) return;

    const timer = window.setTimeout(
      () => {
        setSkeletonVisible(false);
        setSkeletonActive(false);
      },
      SKELETON_FADE_MS,
    );
    return () => window.clearTimeout(timer);
  }, [shouldShow, skeletonActive]);

  return {
    skeletonActive: shouldShow || skeletonActive,
    skeletonClassName: skeletonCrossfadeClassName(
      shouldShow && skeletonVisible,
    ),
  };
};
